module.exports = __webpack_public_path__ + "static/media/symptoms-and-signs.cec3587e.svg";